import React, { useState } from "react";
import { Icon, Button } from "@blueprintjs/core";
import FormatedPrice from "../../components/FormatedPrice";
import CircleStatus from "../../components/CircleStatus";
import { Translate } from "react-redux-i18n";
import CircleImage from "../Image/CircleImage";
import CustomIcon from "../../components/CustomIcon";
import LoadingIndicator from "../../components/LoadingIndicator";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FileCopy } from "@material-ui/icons/";
import CirclePuzzleGift from "../CirclePuzzleGift";
import CirclePrintGiftCard from "../CirclePrintGiftCard";
import {
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookIcon,
  EmailShareButton,
  EmailIcon,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";

const ProductInfoCard = ({
  userHasSigned,
  circle,
  editCircle,
  myGuid,
  purchaseItem,
  purchase_loader,
  copiedToClipboard,
  isWhiteMonday,
  isAdmin,
  sendingPuzzleOrder,
  sendPuzzleOrder,
  is_prylpoolen,
}) => {
  const [expand_description, setDescriptionState] = useState(false);
  const circle_url = `https://app.ihopa.com/circle/${circle.guid}`;
  const social_share_circle_url = isWhiteMonday
    ? circle_url + "?product_tour_id=85337"
    : circle_url + "?product_tour_id=85337"; //always dhow normal onboarding, temporary disable whitemonday

  const show_agreement_info = circle.status === "awaiting_commitment" && !userHasSigned ? true : false;
  const show_wait_agreement_info = circle.status === "awaiting_commitment" && userHasSigned ? true : false;
  const show_share_button = circle.status === "member_gathering" ? true : false;
  const show_purchase_message_admin =
    circle.status === "awaiting_purchase" && myGuid === circle.created_by ? true : false;
  const show_purchase_message_user =
    circle.status === "awaiting_purchase" && myGuid !== circle.created_by ? true : false;

  return (
    <div className="custom-card">
      <div className="product-info">
        <div className="image rounded-product-image size-64">
          <CircleImage size="small" src={circle.products[0].image_url} alt={circle.products[0].name} />
        </div>
        <div className="product-meta">
          {!is_prylpoolen && <CircleStatus circle={circle} />}
          <h1 className="bp3-heading">{circle.products[0].name}</h1>
          <div className="product-location-inline">
            <strong>
              <Translate value="circle_admin.location" />:{" "}
            </strong>
            {circle.address ? circle.address : circle.country}
          </div>
        </div>
        {myGuid === circle.created_by && (
          <Button intent="primary" className="primary-outline" icon="cog" onClick={editCircle} />
        )}
      </div>

      {is_prylpoolen && (
        <div className="product-details">
          <div className="product-meta">
            <div
              className={`prylpool-circle-description product-description default-circle ${
                expand_description ? "expanded" : "collapsed"
              }`}>
              {circle.products[0].url && (
                <a href={circle.products[0].url} target="_blank" rel="noopener noreferrer" className="product-url">
                  <Icon icon="link" iconSize="14" className="icon" />
                  {circle.products[0].url}
                </a>
              )}
              <hr className="separator" />
              <div
                className="mobile-content-expand"
                onClick={() => {
                  setDescriptionState(true);
                }}>
                <Icon icon="more" iconSize="24" className="icon" />
              </div>
              {circle.description}
              {circle.products[0].instructions && (
                <div
                  className="product-instructions"
                  dangerouslySetInnerHTML={{ __html: circle.products[0].instructions }}></div>
              )}
            </div>
          </div>
        </div>
      )}

      {!is_prylpoolen && (
        <>
          <div className="product-split">
            {/* <div className="split-item product-location">
                      <Icon icon="map-marker" iconSize="24" className="icon" />
                      <strong className="ellipsis">{circle.address?circle.address:circle.country}</strong>
                      <span><Translate value="circle_admin.location" /></span>
                  </div> */}
            <div className="split-item product-owners">
              <Icon icon="people" iconSize="24" className="icon" />
              <strong>
                {circle.members.length}/{circle.max_owners_no}
              </strong>
              <span>
                <Translate value="circle_admin.members" />
              </span>
            </div>
            <div className="split-item product-price">
              <CustomIcon name="money-bills" size="24" className="icon" />
              <strong>
                <FormatedPrice
                  value={circle.products[0].price / circle.max_owners_no}
                  currency_type={circle.products[0].currency}
                />
              </strong>
              <span>
                <Translate value="circle_admin.per_person" />
              </span>
            </div>
          </div>

          {show_agreement_info && (
            <div className="circle-notification-cta">
              <div className="notification-content">
                <Icon icon="info-sign" iconSize="16" className="icon" />
                <div className="message">
                  <span>
                    <Translate value="circle_admin.sign_agreement_notification" />
                  </span>
                </div>
              </div>
            </div>
          )}
          {show_wait_agreement_info && (
            <div className="circle-notification-cta">
              <div className="notification-content">
                <Icon icon="info-sign" iconSize="16" className="icon" />
                <div className="message">
                  <span>
                    <Translate value="circle_admin.wait_others_sign_agreement" />
                  </span>
                </div>
              </div>
            </div>
          )}
          {/* {show_share_button && (
        <div className="circle-notification-cta copy-to-clipboard">
          <div className="notification-content">
            <Icon icon="info-sign" iconSize="16" className="icon" />
            <div className="message">
              <Translate value="circle_admin.paragraph1" /> {parseInt(circle.max_owners_no) - circle.members.length}{" "}
              <Translate value="circle_admin.paragraph2" />
            </div>
          </div>
          <CopyToClipboard text={circle_url} onCopy={copiedToClipboard}>
            <Button intent="primary" className="primary-on-dark small copy-button">
              <Translate value="circle_admin.share_button" />
            </Button>
          </CopyToClipboard>
        </div>
      )} */}
          {show_share_button && (
            <>
              <div className="circle-notification-cta social-share">
                <div className="notification-content">
                  <Icon icon="info-sign" iconSize="16" className="icon" />
                  <div className="message">
                    <Translate value="circle_admin.share_on_facebook" />
                  </div>
                </div>
                <div className="social-share-buttons">
                  <FacebookShareButton url={social_share_circle_url}>
                    {/*<Button intent="primary" className="primary-on-dark small share-button">
                <Translate value="circle_admin.share_button_facebook" />
              </Button>*/}
                    <FacebookIcon />
                  </FacebookShareButton>
                  <WhatsappShareButton url={social_share_circle_url}>
                    <WhatsappIcon />
                  </WhatsappShareButton>

                  <EmailShareButton url={social_share_circle_url}>
                    <EmailIcon />
                  </EmailShareButton>
                  <TwitterShareButton url={social_share_circle_url}>
                    <TwitterIcon />
                  </TwitterShareButton>
                  <CopyToClipboard text={social_share_circle_url} onCopy={copiedToClipboard}>
                    <div className="SocialMediaShareButton copy-url">
                      <FileCopy className="icon" />
                    </div>
                  </CopyToClipboard>
                </div>
              </div>
              <div className="white-monday-mobile-actions">
                {isWhiteMonday && isAdmin && (
                  <CirclePuzzleGift circle={circle} sendOrder={sendPuzzleOrder} loading={sendingPuzzleOrder} />
                )}
                {isWhiteMonday && isAdmin && <CirclePrintGiftCard circle={circle} />}
              </div>
            </>
          )}
          {show_purchase_message_user && (
            <div className="circle-notification-cta">
              <div className="notification-content">
                <Icon icon="info-sign" iconSize="16" className="icon" />
                <div className="message">
                  <span>
                    <Translate value="circle_admin.wait_for_purchase" />
                  </span>
                </div>
              </div>
            </div>
          )}
          {show_purchase_message_admin && (
            <div className="circle-notification-cta">
              <div className="notification-content">
                <Icon icon="info-sign" iconSize="16" className="icon" />
                <div className="message">
                  <Translate value="circle_admin.admin_purchase_item" />
                </div>
              </div>
              {purchase_loader && <LoadingIndicator />}
              {!purchase_loader && (
                <Button intent="primary" className="primary-on-dark small" icon="share" onClick={purchaseItem}>
                  <Translate value="circle_admin.purchase_button" />
                </Button>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default ProductInfoCard;
